import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Project } from "pages/Project/Project";
import s from "./WebAR.module.scss";
import { Helmet } from "react-helmet";
import { ButtonDownload } from "shared/components/ButtonDownload/ButtonDownload";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import AOS from "aos";
import WebARPopup from "./WebARPopup/WebARPopup";
import { Link } from "react-router-dom";

export const WebAR = () => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  return (
    <>
      <Helmet
        title="PushKeen - Web AR"
        meta={[
          {
            name: "description",
            content:
              "Web AR — это технология дополненной реальности, которая работает непосредственно в браузере, без необходимости устанавливать дополнительное приложение.",
          },
        ]}
      />
      <Project locales_page="projects" locales_title="webar">
        <section className={s.page}>
          <div
            className={s.main}
            style={{
              backgroundImage:
                "url(" + require(`assets/projects/webar/mainscreen.jpeg`) + ")",
            }}
          >
            <div className="container">
              <div className={s.main_wrapper}>
                <div className={s.main_text}>
                  <h2 data-aos="fade-left" data-aos-duration="1000">
                    {t("project.list.webar.about.title.name")}
                  </h2>
                  <span
                    data-aos="fade-left"
                    data-aos-delay={300}
                    data-aos-duration="1000"
                  >
                    {t("project.list.webar.about.title.label")}
                  </span>
                </div>
                <div className={s.main_new}>new</div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className={s.content}>
              <h3>{t("project.list.webar.about.content.name")}</h3>
              <ReactMarkdown>
                {t("project.list.webar.about.content.label")}
              </ReactMarkdown>
            </div>
            <div className={s.test}>
              <h3>{t("project.list.webar.test.title")}</h3>
              <ul>
                {[1, 2].map((item) => (
                  <li
                    data-aos="fade-left"
                    data-aos-delay={`${100 * item}`}
                    key={item}
                  >
                    <div>{item}</div>
                    <span>{t(`project.list.webar.test.text_${item}`)}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className={s.img_1}>
              <div className={s.label}>
                <span>{t("project.list.webar.label_1")}</span>
                <div onClick={() => setOpen(true)} className={s.button}>
                  <ButtonDownload text={t("project.list.webar.button")} />
                </div>
              </div>
              <img
                src={require("assets/projects/webar/img1.jpg")}
                alt="Playloft Gaga"
              />
            </div>
            <div className={s.market}>
              <div className={s.market_tool}>
                <h3>{t("project.list.webar.market.title")}</h3>
                <ReactMarkdown>
                  {t("project.list.webar.market.text_1")}
                </ReactMarkdown>
                <br />
                <br />
                <ReactMarkdown>
                  {t("project.list.webar.market.text_2")}
                </ReactMarkdown>
              </div>
              <div className={s.market_items}>
                <h4>{t("project.list.webar.market.items.title")}</h4>
                <ul>
                  {[1, 2, 3, 4].map((item) => (
                    <li
                      data-aos="fade-right"
                      data-aos-delay={`${100 * item}`}
                      key={item}
                    >
                      {t(`project.list.webar.market.items.${item}`)}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={s.market_tool}>
                <ReactMarkdown>
                  {t("project.list.webar.market.text_3")}
                </ReactMarkdown>
                <br />
                <ReactMarkdown>
                  {t("project.list.webar.market.text_4")}
                </ReactMarkdown>
              </div>
            </div>
            <div className={s.img_2}>
              <div className={s.label}>
                <span>{t("project.list.webar.label_1")}</span>
                <div onClick={() => setOpen(true)} className={s.button}>
                  <ButtonDownload text={t("project.list.webar.button")} />
                </div>
              </div>
              <img
                src={require("assets/projects/webar/img2.jpg")}
                alt="Playloft Gaga"
              />
              <div className={s.label_2}>
                <div></div>
                <span>{t("project.list.webar.label_2")}</span>
              </div>
            </div>
            <div className={s.integration}>
              <h3>{t("project.list.webar.integration.title")}</h3>
              <br />
              <ReactMarkdown>
                {t("project.list.webar.integration.text_1")}
              </ReactMarkdown>
              <br />
              <ReactMarkdown>
                {t("project.list.webar.integration.text_2")}
              </ReactMarkdown>
            </div>
          </div>
          <div className={s.instruction}>
            <div className="container">
              <div className={s.flex}>
                <div className={s.instruction_wrapper}>
                  <ReactMarkdown>
                    {t("project.list.webar.instruction.title_1")}
                  </ReactMarkdown>
                  <ReactMarkdown>
                    {t("project.list.webar.instruction.title_2")}
                  </ReactMarkdown>
                  <ReactMarkdown>
                    {t("project.list.webar.instruction.title_3")}
                  </ReactMarkdown>
                  <ul>
                    <li data-aos="fade-left" data-aos-delay={`100`}>
                      <div>1</div>
                      <span>
                        {t(`project.list.webar.instruction.text_1`)}
                        <Link to="/">
                          {t(`project.list.webar.instruction.text_2`)}
                        </Link>
                        {t(`project.list.webar.instruction.text_3`)}
                      </span>
                    </li>
                    <li data-aos="fade-left" data-aos-delay={`200`}>
                      <div>2</div>
                      <ReactMarkdown>
                        {t(`project.list.webar.instruction.text_4`)}
                      </ReactMarkdown>
                    </li>
                  </ul>
                </div>
                <div>
                  <svg
                    width="281"
                    height="284"
                    viewBox="0 0 281 284"
                    fill="none"
                  >
                    <rect width="281" height="283.6" rx="56" fill="white" />
                    <g clipPath="url(#clip0_2086_287)">
                      <path
                        d="M38 44H106.654ZM126.269 44H145.885ZM175.308 44H243.962ZM38 53.8077H47.8077ZM96.8462 53.8077H106.654ZM175.308 53.8077H185.116ZM234.154 53.8077H243.962ZM38 63.6154H47.8077ZM57.6154 63.6154H87.0385ZM96.8462 63.6154H106.654ZM116.462 63.6154H126.269ZM136.077 63.6154H145.885ZM175.308 63.6154H185.116ZM194.923 63.6154H224.346ZM234.154 63.6154H243.962ZM38 73.4231H47.8077ZM57.6154 73.4231H87.0385ZM96.8462 73.4231H106.654ZM116.462 73.4231H126.269ZM136.077 73.4231H165.5ZM175.308 73.4231H185.116ZM194.923 73.4231H224.346ZM234.154 73.4231H243.962ZM38 83.2308H47.8077ZM57.6154 83.2308H87.0385ZM96.8462 83.2308H106.654ZM116.462 83.2308H126.269ZM136.077 83.2308H165.5ZM175.308 83.2308H185.116ZM194.923 83.2308H224.346ZM234.154 83.2308H243.962ZM38 93.0385H47.8077ZM96.8462 93.0385H106.654ZM116.462 93.0385H126.269ZM136.077 93.0385H145.885ZM155.692 93.0385H165.5ZM175.308 93.0385H185.116ZM234.154 93.0385H243.962ZM38 102.846H106.654ZM116.462 102.846H126.269ZM136.077 102.846H145.885ZM155.692 102.846H165.5ZM175.308 102.846H243.962ZM116.462 112.654H126.269ZM145.885 112.654H165.5ZM38 122.462H47.8077ZM57.6154 122.462H106.654ZM126.269 122.462H145.885ZM155.692 122.462H165.5ZM175.308 122.462H224.346ZM38 132.269H57.6154ZM67.4231 132.269H96.8462ZM106.654 132.269H126.269ZM155.692 132.269H175.308ZM194.923 132.269H243.962ZM38 142.077H47.8077ZM67.4231 142.077H106.654ZM136.077 142.077H155.692ZM165.5 142.077H185.116ZM214.539 142.077H234.154ZM47.8077 151.885H67.4231ZM77.2308 151.885H87.0385ZM116.462 151.885H126.269ZM194.923 151.885H224.346ZM38 161.692H57.6154ZM67.4231 161.692H126.269ZM136.077 161.692H155.692ZM165.5 161.692H185.116ZM194.923 161.692H204.731ZM234.154 161.692H243.962ZM116.462 171.5H126.269ZM155.692 171.5H165.5ZM185.116 171.5H204.731ZM224.346 171.5H243.962ZM38 181.308H106.654ZM136.077 181.308H145.885ZM155.692 181.308H194.923ZM214.539 181.308H224.346ZM38 191.116H47.8077ZM96.8462 191.116H106.654ZM116.462 191.116H126.269ZM155.692 191.116H165.5ZM194.923 191.116H204.731ZM214.539 191.116H224.346ZM38 200.923H47.8077ZM57.6154 200.923H87.0385ZM96.8462 200.923H106.654ZM116.462 200.923H136.077ZM145.885 200.923H185.116ZM194.923 200.923H204.731ZM224.346 200.923H243.962ZM38 210.731H47.8077ZM57.6154 210.731H87.0385ZM96.8462 210.731H106.654ZM116.462 210.731H136.077ZM185.116 210.731H214.539ZM38 220.539H47.8077ZM57.6154 220.539H87.0385ZM96.8462 220.539H106.654ZM116.462 220.539H165.5ZM175.308 220.539H185.116ZM38 230.346H47.8077ZM96.8462 230.346H106.654ZM126.269 230.346H136.077ZM165.5 230.346H175.308ZM204.731 230.346H224.346ZM38 240.154H106.654ZM116.462 240.154H155.692ZM175.308 240.154H204.731ZM224.346 240.154H234.154Z"
                        fill="black"
                      />
                      <path
                        d="M38 44H106.654M126.269 44H145.885M175.308 44H243.962M38 53.8077H47.8077M96.8462 53.8077H106.654M175.308 53.8077H185.116M234.154 53.8077H243.962M38 63.6154H47.8077M57.6154 63.6154H87.0385M96.8462 63.6154H106.654M116.462 63.6154H126.269M136.077 63.6154H145.885M175.308 63.6154H185.116M194.923 63.6154H224.346M234.154 63.6154H243.962M38 73.4231H47.8077M57.6154 73.4231H87.0385M96.8462 73.4231H106.654M116.462 73.4231H126.269M136.077 73.4231H165.5M175.308 73.4231H185.116M194.923 73.4231H224.346M234.154 73.4231H243.962M38 83.2308H47.8077M57.6154 83.2308H87.0385M96.8462 83.2308H106.654M116.462 83.2308H126.269M136.077 83.2308H165.5M175.308 83.2308H185.116M194.923 83.2308H224.346M234.154 83.2308H243.962M38 93.0385H47.8077M96.8462 93.0385H106.654M116.462 93.0385H126.269M136.077 93.0385H145.885M155.692 93.0385H165.5M175.308 93.0385H185.116M234.154 93.0385H243.962M38 102.846H106.654M116.462 102.846H126.269M136.077 102.846H145.885M155.692 102.846H165.5M175.308 102.846H243.962M116.462 112.654H126.269M145.885 112.654H165.5M38 122.462H47.8077M57.6154 122.462H106.654M126.269 122.462H145.885M155.692 122.462H165.5M175.308 122.462H224.346M38 132.269H57.6154M67.4231 132.269H96.8462M106.654 132.269H126.269M155.692 132.269H175.308M194.923 132.269H243.962M38 142.077H47.8077M67.4231 142.077H106.654M136.077 142.077H155.692M165.5 142.077H185.116M214.539 142.077H234.154M47.8077 151.885H67.4231M77.2308 151.885H87.0385M116.462 151.885H126.269M194.923 151.885H224.346M38 161.692H57.6154M67.4231 161.692H126.269M136.077 161.692H155.692M165.5 161.692H185.116M194.923 161.692H204.731M234.154 161.692H243.962M116.462 171.5H126.269M155.692 171.5H165.5M185.116 171.5H204.731M224.346 171.5H243.962M38 181.308H106.654M136.077 181.308H145.885M155.692 181.308H194.923M214.539 181.308H224.346M38 191.116H47.8077M96.8462 191.116H106.654M116.462 191.116H126.269M155.692 191.116H165.5M194.923 191.116H204.731M214.539 191.116H224.346M38 200.923H47.8077M57.6154 200.923H87.0385M96.8462 200.923H106.654M116.462 200.923H136.077M145.885 200.923H185.116M194.923 200.923H204.731M224.346 200.923H243.962M38 210.731H47.8077M57.6154 210.731H87.0385M96.8462 210.731H106.654M116.462 210.731H136.077M185.116 210.731H214.539M38 220.539H47.8077M57.6154 220.539H87.0385M96.8462 220.539H106.654M116.462 220.539H165.5M175.308 220.539H185.116M38 230.346H47.8077M96.8462 230.346H106.654M126.269 230.346H136.077M165.5 230.346H175.308M204.731 230.346H224.346M38 240.154H106.654M116.462 240.154H155.692M175.308 240.154H204.731M224.346 240.154H234.154"
                        stroke="black"
                        strokeWidth="10.0039"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2086_287">
                        <rect
                          width="207"
                          height="207.6"
                          fill="white"
                          transform="translate(37 38)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <button>
                    <a
                      href="https://8th.io/w32nd"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("project.list.webar.popup.button")}
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Project>

      <WebARPopup open={open} setOpen={setOpen} />
    </>
  );
};
